import React, { useState, useEffect } from 'react';
import axios from 'axios';
import img from "../../assets/images/flat.jpg";
import { FaWhatsapp, FaPhoneAlt, FaBed, FaBath, FaDoorOpen } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import BottomNav from '../../component/BottomNav';
import FreeListing_property from '../../component/FreeListing_property';
import { API_URL } from '../../common/constant';
import Loader from '../loader/Loader';
import WhatsAppButton from '../Whatsappbtn';
import FAQ from '../FAQ/FAQ';


const phoneNumber = '8318150076';

const Sell_property_Card_page = () => {
    const navigate = useNavigate();
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProperties = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/property/get-all-sell-properties`);
                console.log(response)
                setProperties(response?.data?.properties);
                setError(" ")
            } catch (err) {
                setError("No Property Found");
            } finally {
                setLoading(false);
            }
        };
        fetchProperties();
    }, []);

    const handleWhatsappClick = (event) => {
        event.stopPropagation();
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };

    // const handleNavigate = (propertyId) => {
    //     navigate(`/for-rent-property/${propertyId}`);
    // };
    const handleNavigate = (id) => {
        navigate(`/for-sale-property/${id}`); // Correct route for sale properties
    };
    if (loading) {

    }

    return (
        <div className="relative p-2 mx-4 flex flex-wrap gap-8">
            <div className="w-full lg:w-2/3 flex flex-col gap-8">
                <h1 className='py-4 text-[#54BD95] text-4xl font-bold mx-8'>Property for Sale in Lucknow</h1>
                {loading ? (
                    <Loader />
                ) : error ? (
                    <p className="text-red-500">{error}</p>
                ) : (
                    properties?.map((property) => (
                        <div
                            key={property?.id}
                            className="bg-white shadow-lg p-6 rounded-lg transition-all hover:shadow-xl hover:scale-105 cursor-pointer flex flex-col lg:flex-row"
                            onClick={() => handleNavigate(property._id)}
                        >
                            <div className="mb-6 lg:mb-0 lg:w-1/3">
                                <img
                                    src={`${API_URL}/uploads/properties/${property._id}/${property?.mainImage}`}
                                    alt="Property"
                                    className="h-60 w-full object-cover rounded-lg shadow-md transform transition-all duration-500 hover:scale-105"
                                />
                            </div>

                            <div className="lg:ml-6 text-gray-800 lg:w-2/3">
                                <h2 className="text-2xl font-semibold mb-2 hover:text-[#54BD95]">{`${property.bhk} For Sale`}</h2>
                                <p className="text-sm text-gray-500 mt-2">{property.address}</p>
                                <div className="mt-4 space-y-2">
                                    <div className="flex items-center gap-2">
                                        <FaBed className=" text-[#54BD95]" />
                                        <span>{property?.bed} Bed</span>
                                        <FaBath className=" text-[#54BD95]" />
                                        <span>{property?.bathroom} Bath</span>
                                        <FaDoorOpen className=" text-[#54BD95]" />
                                        <span>{property?.balcony} Balcony</span>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-sm font-medium">Price:</p>
                                        <p className="text-lg font-bold text-[#54BD95] ml-4">₹{property?.propertyPrice}</p>
                                    </div>

                                    <div className="flex items-center">
                                        <p className="text-sm font-medium">Furnish Status:</p>
                                        <p className="text-lg font-bold text-[#54BD95] ml-4">{property?.furnishedType}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-6 lg:mt-0 lg:ml-6 lg:flex-row lg:items-center gap-4">
                                <button
                                    onClick={handleWhatsappClick}
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6 rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 my-6 py-2"
                                >
                                    <FaWhatsapp className="text-white mr-2" size={20} />
                                    <span className="text-lg">WhatsApp</span>
                                </button>
                                <a
                                    href={`tel:${phoneNumber}`}
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6 rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 mt-6 py-2"
                                >
                                    <FaPhoneAlt className="text-white mr-3" size={20} />
                                    <span className="text-lg">Contact</span>
                                </a>
                            </div>
                        </div>
                    ))
                )}
            </div>
            <FreeListing_property />
            <WhatsAppButton/>
            <div className='w-full'>
                <FAQ/>
                </div>
            <BottomNav />
        </div>
    );
};

export default Sell_property_Card_page;
